function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #ee6c4d } \n\t");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "Background",
  className: "shp0",
  d: "M40 0L216 0C238.12 0 256 17.88 256 40L256 216C256 238.12 238.12 256 216 256L40 256C17.88 256 0 238.12 0 216L0 40C0 17.88 17.88 0 40 0Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "C ",
  fill: "#ffffff",
  d: "M98.64 107.61Q98.4 110.73 98.16 116.25Q98.16 121.77 98.16 127.77Q98.16 133.53 98.16 139.29Q98.4 144.81 98.64 147.93Q99.12 153.45 100.8 158.49Q102.48 163.53 106.08 167.37Q109.68 171.21 115.2 173.61Q120.72 175.77 128.88 175.77Q137.04 175.77 142.32 173.85Q147.6 171.93 150.96 169.29Q154.32 166.41 156 163.05Q157.92 159.69 158.88 156.81Q160.08 152.97 161.52 151.53Q162.96 149.85 167.04 149.85L198.48 149.85Q200.64 149.85 202.08 151.53Q203.76 152.97 203.76 155.13Q203.52 167.37 197.76 178.17Q192 188.97 181.92 196.89Q171.84 204.81 158.16 209.61Q144.72 214.17 128.88 214.17Q111.6 214.17 97.92 209.13Q84.48 203.85 74.88 194.97Q65.28 186.09 60 174.33Q54.96 162.33 54.24 149.13Q53.76 139.29 53.76 128.01Q53.76 116.73 54.24 106.41Q54.72 93.21 60 81.45Q65.28 69.45 74.64 60.57Q84.24 51.69 97.92 46.65Q111.6 41.37 128.88 41.37Q144.72 41.37 158.16 46.17Q171.84 50.73 181.92 58.65Q192 66.57 197.76 77.37Q203.52 88.17 203.76 100.41Q203.76 102.57 202.08 104.25Q200.64 105.69 198.48 105.69L167.04 105.69Q162.96 105.69 161.52 104.25Q160.08 102.57 158.88 98.73Q157.92 95.85 156 92.49Q154.32 89.13 150.96 86.49Q147.6 83.61 142.32 81.69Q137.04 79.77 128.88 79.77Q120.72 79.77 115.2 82.17Q109.68 84.33 106.08 88.17Q102.48 92.01 100.8 97.05Q99.12 102.09 98.64 107.61Z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    width: 256,
    height: 256,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.fbefff43.svg";
export { ForwardRef as ReactComponent };